/**
 * Tiny prefixed logger so all console output from the app is easy to filter
 * (search "[photobooth" in the devtools console). Each module makes its own
 * tagged instance.
 */

type LogFn = (...args: unknown[]) => void;

export interface Logger {
  debug: LogFn;
  info: LogFn;
  warn: LogFn;
  error: LogFn;
}

const STYLES: Record<keyof Logger, string> = {
  debug: 'color:#888',
  info: 'color:#4ea1f5',
  warn: 'color:#e6a23c',
  error: 'color:#f56c6c;font-weight:bold',
};

export function logger(tag: string): Logger {
  const make = (level: keyof Logger): LogFn => {
    const method = console[level === 'debug' ? 'log' : level].bind(console);
    return (...args: unknown[]) =>
      method(`%c[photobooth:${tag}]`, STYLES[level], ...args);
  };
  return {
    debug: make('debug'),
    info: make('info'),
    warn: make('warn'),
    error: make('error'),
  };
}
